import {
  CASES_ACTIVE_TAB,
  COUNTRIES_LIST,
  DROP_D0WNS,
  EDIT_CASE_STATUS,
  EDIT_PROJECT_STATUS,
  IS_DENTAL_RECORD_SCREEN,
  IS_DIRTY,
  META_DATA,
  SET_MY_INFO,
  SET_MY_ORGANIZATION,
  SET_PROJECT_DETAILS_CASE_TAB,
  SET_PROJECT_DETAILS_TAB,
  SET_PROJECT_FILTER_TAB,
  SET_PROJECT_STATUS,
  SITE_DATA,
  TOGGLE_EDIT_STATE,
} from "../actions/generalAction";

const initialState = {
  selectedProjectTab: "all",
  selectedProjectDetailTab: "details",
  selectedProjectDetailCaseTab: "all",
  selectdCasesActiveTab: "all",
  dropdowns: null,
  countriesList: [],
  metaData: null,
  siteData: null,
  isDirty: false,
  isDentalRecordScreen: false,
  isEditProject: false,
  isEditCase: false,
  myOrganization: null,
  myInfo: null,
  isProjectOpenForCollaboration: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PROJECT_FILTER_TAB:
      return {
        ...state,
        selectedProjectTab: action.payload,
      };

      break;
    case SET_PROJECT_DETAILS_TAB:
      return {
        ...state,
        selectedProjectDetailTab: action.payload,
      };

      break;
    case SET_PROJECT_DETAILS_CASE_TAB:
      return {
        ...state,
        selectedProjectDetailCaseTab: action.payload,
      };

      break;
    case DROP_D0WNS:
      return {
        ...state,
        dropdowns: action.payload,
      };

      break;
    case COUNTRIES_LIST:
      return {
        ...state,
        countriesList: action.payload,
      };

      break;

    case META_DATA:
      return {
        ...state,
        metaData: action.payload,
      };

      break;
    case SITE_DATA:
      return {
        ...state,
        siteData: action.payload,
      };
      break;
    case IS_DIRTY:
      return {
        ...state,
        isDirty: action.payload,
      };
      break;
    case IS_DENTAL_RECORD_SCREEN:
      return {
        ...state,
        isDentalRecordScreen: action.payload,
      };
      break;
    case EDIT_PROJECT_STATUS:
      return {
        ...state,
        isEditProject: action.payload,
      };
      break;
    case EDIT_CASE_STATUS:
      return {
        ...state,
        isEditCase: action.payload,
      };
      break;
    case CASES_ACTIVE_TAB:
      return {
        ...state,
        selectdCasesActiveTab: action.payload,
      };
      break;
    // case SET_MY_ORGANIZATION:
    //   return {
    //     ...state,
    //     myOrganization: action.payload,
    //   };
    //   break;
    case SET_MY_ORGANIZATION:
      {
        const org = action.payload;

        // Check if active_subscription is empty {}
        const hasActive =
          org.active_subscription &&
          Object.keys(org.active_subscription).length > 0;

        // If no active subscription, pick latest subscription from list
        if (!hasActive && Array.isArray(org.subscriptions)) {
          const latest = org.subscriptions
            .slice()
            .sort((a, b) => new Date(b.start_at) - new Date(a.start_at))[0];

          if (latest) {
            org.active_subscription = latest;
          }
        }

        return {
          ...state,
          myOrganization: org,
        };
      }
      break;
    case SET_MY_INFO:
      return {
        ...state,
        myInfo: action.payload,
      };
      break;
    case SET_PROJECT_STATUS:
      return {
        ...state,
        isProjectOpenForCollaboration: action.payload,
      };
      break;
    default:
      return state;
      break;
  }
}
